import CustomerTableContentCommu from "./CustomerTableContentCommu";

const CustomerTableCommu = () => {
  return <CustomerTableContentCommu />;
};

export default CustomerTableCommu;
